import axios from 'axios';

export default class PasswordChange
{
    constructor ()
    {

        this.formContainer = document.querySelector( '#password-change-form-container' );
        this.form          = this.formContainer.querySelector( '#password-change-form' );


        // we're probably in "Cannot change password" mode (didn'T have a valid token)
        if ( this.form === null )
        {
            return;
        }

        this.inputToken = this.form.querySelector( '#token' );
        this.token      = this.inputToken.value;

        this.inputPassword             = this.form.querySelector( '#input-password' );
        this.password                  = '';
        this.inputPasswordConfirmation = this.form.querySelector( '#input-password-confirmation' );
        this.passwordConfirmation      = '';

        this.btnSubmit = this.form.querySelector( '#btn_send' );

        this.errorPassword             = this.form.querySelector( '#error_password' );
        this.errorPasswordConfirmation = this.form.querySelector( '#error_password_confirmation' );

        this.successMessage = this.formContainer.querySelector( '#message_success' );

        axios.defaults.headers.common = {
            'X-Requested-With' : 'XMLHttpRequest',
            'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
        };


        this.resetErrors();
        this.adjustSubmitButton();

        this.bindEvents();
    }


    bindEvents ()
    {
        this.form.addEventListener( 'submit', this.handleSubmit.bind( this ) );

        this.inputPassword.addEventListener( 'keyup', ( e ) =>
        {
            this.password = this.inputPassword.value;
            this.adjustSubmitButton();

        } );

        this.inputPasswordConfirmation.addEventListener( 'keyup', ( e ) =>
        {
            this.passwordConfirmation = this.inputPasswordConfirmation.value;
            this.adjustSubmitButton();

        } );
    }


    async handleSubmit ( e )
    {
        e.preventDefault();

        if ( this.token === '' || this.password === '' || this.passwordConfirmation === '' )
        {
            return;
        }

        this.resetErrors();

        this.btnSubmit.disabled = true;
        this.btnSubmit.classList.add( "ajaxing" );

        let response = await axios.post( `/endpoints/user/change-password`, {
            token                 : this.token,
            password              : this.password,
            password_confirmation : this.passwordConfirmation,
        } );


        const success = response.data.success;
        const errors  = response.data?.errors ?? [];


        if ( success )
        {
            this.successMessage.style.display = 'block';
            this.form.style.display           = 'none';
        } else
        {

            if ( typeof errors.password !== 'undefined' && errors.password.length > 0 )
            {
                this.errorPassword.innerHTML     = errors.password.join( '<br>' );
                this.errorPassword.style.display = 'block';
            }

            if ( typeof errors.password_confirmation !== 'undefined' && errors.password_confirmation.length > 0 )
            {
                this.errorPasswordConfirmation.innerHTML     = errors.password_confirmation.join( '<br>' );
                this.errorPasswordConfirmation.style.display = 'block';
            }


        }


        this.btnSubmit.disabled = false;
        this.btnSubmit.classList.remove( "ajaxing" );


    }

    resetErrors ()
    {
        this.errorPassword.innerHTML     = '';
        this.errorPassword.style.display = 'none';

        this.errorPasswordConfirmation.innerHTML     = '';
        this.errorPasswordConfirmation.style.display = 'none';
    }

    adjustSubmitButton ()
    {
        this.btnSubmit.disabled = this.password === '' || this.passwordConfirmation === '';
    }

    doPasswordsMatch ()
    {

        return this.password === this.passwordConfirmation;
    }
}

if ( document.body.classList.contains( 'password-change-page' ) )
{
    const passwordChange = new PasswordChange();
}
